import { z } from "zod";

import { buildNamespace } from "@smart/itops-types-basic";

import { system } from "./base";

export const CustomisedContactDetailsNS = buildNamespace({
  system,
  entity: "CustomisedContactDetails",
} as const);

export const customisedContactDetailsFieldSchema = z.object({
  fieldName: z.string(),
  label: z.string(),
});

export const CustomisedContactDetailsSchema = z.object({
  uri: CustomisedContactDetailsNS.schema,
  operationId: z.string(),

  teamUri: z.string(),
  name: z.string(),
  roleName: z.string(),
  contactType: z.enum(["person", "company"]),
  fields: z.array(customisedContactDetailsFieldSchema),

  createdAt: z.string(),
  updatedAt: z.string().optional(),

  deleted: z.boolean().optional(),
  deletedAtSec: z.number().optional(),
});

export type CustomisedContactDetailsField = z.infer<
  typeof customisedContactDetailsFieldSchema
>;

export type CustomisedContactDetails = z.infer<
  typeof CustomisedContactDetailsSchema
>;
